import { AgreementList } from '../types';

/** Same rules as backend bulk invoices / is_agreement_selectable. */
export function isAgreementSelectable(agreement: AgreementList): boolean {
  if (agreement.active === false) {
    return false;
  }
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (agreement.start_date) {
    const start = new Date(agreement.start_date);
    start.setHours(0, 0, 0, 0);
    if (today < start) {
      return false;
    }
  }
  if (agreement.end_date) {
    const end = new Date(agreement.end_date);
    end.setHours(0, 0, 0, 0);
    if (today > end) {
      return false;
    }
  }
  return true;
}
